export default function Toast({ msg }) {
  if (!msg) return null;
  return (
    <div style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 9999,
      background: "rgba(26,26,46,0.92)",
      color: "#fff",
      padding: "20px 32px",
      borderRadius: 16,
      fontSize: 15,
      fontWeight: 600,
      boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
      whiteSpace: "nowrap",
      textAlign: "center"
    }}>
      {msg}
    </div>
  );
}